import { render } from "./TabEmail.vue?vue&type=template&id=ca6dc456"
import script from "./TabEmail.vue?vue&type=script&lang=js"
export * from "./TabEmail.vue?vue&type=script&lang=js"

import "./TabEmail.vue?vue&type=style&index=0&id=ca6dc456&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__